module.exports = __webpack_public_path__ + "img/img-modal-photo4.webp";